import Guard from '../../services/Middleware'

export default [
  {
    path: '/Almoxarifado',
    name:'Almoxarifado',
    component: () => import('@/views/almoxarifado/Index.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/Fornecedores',
    name:'Fornecedores',
    component: () => import('@/views/almoxarifado/FornecedoresIndex.vue'),
    beforeEnter: Guard.auth,
  },
  {
    path: '/Almoxarifado/Categorias',
    name:'Categorias',
    component: () => import('@/views/almoxarifado/CategoriasIndex.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/TipoProduto',
    name:'Tipo de Produto',
    component: () => import('@/views/almoxarifado/TipoProdutoIndex.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/Produtos',
    name:'Produtos',
    component: () => import('@/views/almoxarifado/ProdutoIndex.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/Ajuda',
    name:'Ajuda',
    component: () => import('@/views/almoxarifado/AjudaIndex.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/Estoque',
    name:'Estoque',
    component: () => import('@/views/almoxarifado/EstoqueIndex.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/Equipamentos',
    name:'Equipamentos',
    component: () => import('@/views/almoxarifado/EquipamentosIndex.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/AdicionarNfe',
    name:'Almoxarifado',
    component: () => import('@/views/almoxarifado/AddNfe.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Almoxarifado/AdicionarNfe/:chave',
    name:'Editar NF-e',
    component: () => import('@/views/almoxarifado/AddNfe.vue'),
    beforeEnter: Guard.auth
  },
]